export default __webpack_public_path__ + "static/media/userprofile.f65169f8.svg";